import React from 'react';
import { useParams } from 'react-router-dom';
import Header from "./Header";

interface Content {
    type: 'text' | 'image';
    data: string;
}

interface Document {
    title: string;
    contents: Content[];
}

interface DocumentDetailProps {
    documents: Document[];
}

const DocumentDetail: React.FC<DocumentDetailProps> = ({ documents }) => {
    const { title } = useParams<{ title: string }>();
    const document = documents.find(doc => encodeURIComponent(doc.title) === title);

    // @ts-ignore
    return (
        <div>
            <h1>{document?.title}</h1>
            {document?.contents.map((content, index) => (
                <div key={index}>
                    {content.type === 'text' ? (
                        <p>{content.data}</p>
                    ) : (
                        <img src={content.data} alt="Document visual content" />
                    )}
                </div>
            ))}
        </div>
    );
};

export default DocumentDetail;
